import React from 'react';
import { Link } from 'react-router-dom';
import CatalogImage from '../catalog/CatalogImage';

/**
 * Shopify-style collection tile — full-card link, portrait image, minimal text.
 */
export default function CollectionShelfCard({
  to,
  name,
  image = '',
  countLabel = '',
  compact = false,
}) {
  const hasImage = String(image || '').trim() !== '';

  return (
    <Link
      to={to}
      className={`collection-shelf-card${compact ? ' collection-shelf-card--compact' : ''}`}
    >
      <div className="collection-shelf-card__media">
        {hasImage ? (
          <CatalogImage
            src={image}
            alt={name}
            className="collection-shelf-card__img"
            sizes={compact ? '(max-width: 768px) 40vw, 200px' : '(max-width: 768px) 45vw, 280px'}
          />
        ) : (
          <div className="collection-shelf-card__placeholder" aria-hidden>
            <span className="collection-shelf-card__placeholder-mark">{name.slice(0, 1)}</span>
          </div>
        )}
        <span className="collection-shelf-card__shade" aria-hidden />
        <span className="collection-shelf-card__cta">Shop collection</span>
      </div>
      <div className="collection-shelf-card__body">
        <h3 className="collection-shelf-card__title">{name}</h3>
        {countLabel ? <p className="collection-shelf-card__meta">{countLabel}</p> : null}
      </div>
    </Link>
  );
}
